import {Chain} from '../../models';
import {makeAsyncReducer, composeReducers, StateAsyncProperty} from '../../redux-toolbelt';

import {getChains} from './chainsActions';

export type ChainState = StateAsyncProperty<Partial<Chain>[]>;

export default composeReducers<ChainState>(makeAsyncReducer(getChains));
